export interface NotificationDropdown {
  type: NotificationType;
  title: string;
  message: string;
  date: string;
  avatar: string;
  unread: boolean;
}
export type NotificationType = 'ADIR Summary' | 'Announcement';

export enum NotificationNavigationRequestType {
  ADIR = 1,
  FDP = 2,
}
